// NotFound.js
import React from "react";
import { Link } from "react-router-dom";
import "./NotFound.css";

const NotFound = () => {
  return (
    <div className="not-found-container">
      <h1>404</h1>
      <h2>Aquesta pàgina no existeix</h2>
      <p>La pàgina que estàs cercant no ha pogut ser trobada.</p>
      <Link to="/" className="home-button">
        Tornar a l'inici
      </Link>
    </div>
  );
};

export default NotFound;
